<template>
    <div class="box box-align-center box-pack-between main platform-user">
        <div class="height100 whiteBg pu-left">
            <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="用户组" name="1"></el-tab-pane>
                <el-tab-pane label="用户" name="2"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="whiteBg height100 ml12 pu-right">
            <user-group v-if="activeName == '1'"></user-group>
            <user v-else></user>
        </div>
    </div>
</template>
<script>
import UserGroup from './components/userGroup.vue';
import User from './components/user.vue';
export default {
    components: {
        UserGroup,
        User
    },
    data() {
        return {
            tabPosition: 'left',
            activeName: '1'
        }
    },
    mounted() {

    },
    methods: {
        handleClick() {

        }
    }
}
</script>
<style lang="scss" scoped>
/deep/.el-tabs--left .el-tabs__header.is-left {
    margin-right: 0;
    width: 100%;
}

/deep/.el-tabs--left .el-tabs__item.is-left {
    text-align: center;
}

.platform-user {
    padding: 24px 33px;

    .pu-left {
        width: 100px;
    }

    .pu-right {
        flex: 1;
    }
}
</style>